module.exports = __webpack_public_path__ + "img/delano6.76682761.jpg";